// src/components/Movies/MovieCard.jsx
import React from 'react';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
} from '@mui/material';
import {
  Star,
  CalendarToday,
} from '@mui/icons-material';

interface MovieCardProps {
  movie: Movie;
  onClick: () => void;
}

export function MovieCard({ movie, onClick }: MovieCardProps) {
  const releaseYear = new Date(movie.release_date).getFullYear();
  
  return (
    <Card 
      className="flex-shrink-0 w-48 sm:w-56 cursor-pointer transition-transform hover:scale-105 active:scale-95"
      onClick={onClick}
    >
      <CardContent className="p-0">
        <div className="relative">
          <CardMedia
            component="img"
            height="320"
            image={movie.posterPath || movie.poster_path || movie.poster || '/placeholder-movie.svg'}
            alt={movie.name || movie.title}
            sx={{ 
              cursor: 'pointer',
              objectFit: 'cover',
              width: '100%',
              aspectRatio: '2/3'
            }}
          />
          <div className="absolute top-2 right-2">
            {/* Assuming Badge is imported or defined elsewhere */}
            {/* <Badge variant="secondary" className="text-xs">
              {movie.content_type}
            </Badge> */}
          </div>
          {movie.rating > 0 && (
            <div className="absolute top-2 left-2 bg-black/70 rounded-md px-2 py-1 flex items-center gap-1">
              <Star sx={{ fontSize: 16, color: 'gold' }} />
              <span className="text-white text-xs">{movie.rating}</span>
            </div>
          )}
        </div>
        
        <div className="p-3 space-y-2">
          <Typography 
            variant="h6" 
            component="h3" 
            sx={{ 
              fontSize: '0.9rem',
              fontWeight: 'bold',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {movie.name}
          </Typography>
          
          <Box display="flex" alignItems="center" gap={1} mt={1}>
            <CalendarToday sx={{ fontSize: 16, color: 'text.secondary' }} />
            <Typography variant="caption" color="text.secondary">
              {releaseYear}
            </Typography>
          </Box>
          
          {/* Assuming Badge is imported or defined elsewhere */}
          {/* <div className="flex flex-wrap gap-1">
            {movie.genre.split(', ').slice(0, 2).map((g) => (
              <Badge key={g} variant="outline" className="text-xs">
                {g}
              </Badge>
            ))}
          </div> */}
          
          <Typography variant="caption" color="text.secondary" sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          }}>
            {movie.summary}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
}

export default MovieCard;
